import React from "react";

const SuspenseLoader = () => {
    return (
        <div className="suspense-loader">
            <div className="loader-content">
                <div className="logo-loader"></div>
                <p>Loading VarahiSoft Experience...</p>
            </div>
        </div>
    );
};

export default SuspenseLoader;